module.exports = __webpack_public_path__ + "static/media/alex.be796ba8.jpg";